import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Factor = () => {

    let userData = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : {};

    const { id } = useParams();
    const [serviceConsumer, setServiceConsumer] = useState({});
    const [payments, setPayments] = useState({});
    const { readData: getServiceConsumer } = useEntityCrud('ServiceConsumer/GetServiceConsumer');
    const { readData: getAllPayments } = useEntityCrud('Payment/GetAllPayments');
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [paidTypesTitle, setPaidTypesTitle] = useState(0);
    const [fetchedData,setFetchedData] = useState(false);

    useEffect(() => {
        const postedData = {
            serviceConsumerId: parseInt(id),
            additionalInfo: []
        };
        getAllPayments({
            ...postedData,
            pan: '',
            rrn: '',
            terminalId: '',
            responseCode: ''
        }).then(({ data }) => {
            let generatePayments = [];
            let paidTypes = [];
            if (data.status) {
                data.result.map(payment => {
                    if (payment.responseCode == '00') {
                        generatePayments.push({
                            status: payment.status,
                            paymentType: payment.paymentType || 1,
                            responseCode: payment.responseCode,
                            amount: payment.amount
                        });
                        if (!paidTypes.includes(payment.paymentType || 1))
                            paidTypes.push(payment.paymentType || 1);
                        setTotalPaidAmount(amount => amount + payment.amount);
                    }
                });
                let paidTitle = paidTypes.length == 0 ? 'بدون پرداخت' : paidTypes.length == 1 ? (paidTypes[0] == 1 ? 'اعتباری' : paidTypes[0] == 2 ? 'شتابی' : 'نقدی') : (paidTypes.includes(1) && paidTypes.includes(2) ? 'اعتباری / شتابی' : paidTypes.includes(1) && paidTypes.includes(3) ? 'اعتباری / نقدی' : 'شتابی / نقدی');
                setPaidTypesTitle(old => paidTitle);
            }
            setPayments(generatePayments);
        })
        getServiceConsumer(postedData).then(({ data }) => {
            if (data.status) {
                let generatedServiceConsumer = {
                    ...data.result
                };
                let subServices = [];
                data.result.subServiceId.map(subService => {
                    if (subServices.findIndex(item => item.id == subService.id) >= 0)
                        subServices[subServices.findIndex(item => item.id == subService.id)].count += 1;
                    else
                        subServices.push({
                            id: subService.id,
                            title: subService.title,
                            price: subService.price,
                            count: 1
                        });
                    let totalServiceCount = subServices.length;
                    let totalServicePrice = 0;
                    subServices.map(service => {
                        totalServicePrice += service.price;
                    })
                    generatedServiceConsumer['totalServiceCount'] = totalServiceCount;
                    generatedServiceConsumer['totalServicePrice'] = totalServicePrice;
                    generatedServiceConsumer['subServices'] = subServices;
                    let additionalInfo = {};
                    if (data.result.additionalInfo) {
                        data.result.additionalInfo.map(item => {
                            additionalInfo[item.key] = item.value;
                        })
                    }
                    generatedServiceConsumer['additionalInfo'] = additionalInfo;
                })
                setServiceConsumer(generatedServiceConsumer);

            }
        }).finally(() => {
            setFetchedData(true);
        });
    }, [])

    useEffect(() => {
        if(fetchedData && Object.keys(serviceConsumer).length)
            window.print();
    }, [fetchedData,serviceConsumer])

    if(!Object.keys(serviceConsumer).length)
        return <p className="text-center py-4">در حال بارگذاری ...</p>

    return (


        <div className="card custom-card-padding mb-0" style={{ height: '100vh' }}>
            <div className="card-body custom-card-padding">
                <h3 style={{ textAlign: 'center' }}><b>فاکتور خرید </b></h3>
                <h3 style={{ textAlign: 'center' }}><b>{serviceConsumer.businessTitle}</b></h3>
                <br />
                <div style={{ border: '2px solid #919090', margin: 20, borderRadius: 10 }}>
                    <div className="row" >
                        <div className="col-md-6 p-4 " style={{ width: '50%', display: 'block', borderLeft: '2px solid #919090' }}>
                            <div className='p-4'>

                                <h5 className='pb-2'>
                                    <b>
                                        اطلاعات خریدار
                                    </b>
                                </h5>
                                <div style={{ width: '100%', display: 'block' }} className='mr-4'>
                                    <div style={{ display: 'inline-block', width: '50%', margin: 0 }}>
                                        <h5 style={{ marginBottom: 18 }}>نام خدمت گیرنده : {serviceConsumer.personFullName}</h5>
                                        <h5 style={{ marginBottom: 18 }}>کد ملی خدمت گیرنده : {serviceConsumer.nationalCode}</h5>
                                        <h5 style={{ marginBottom: 18 }}>تاریخ : {serviceConsumer.registerDate ? (serviceConsumer.registerDate.toString().slice(0, 4) + '/' + serviceConsumer.registerDate.toString().slice(4, 6) + '/' + serviceConsumer.registerDate.toString().slice(6, 8)) : ''}</h5>
                                        {serviceConsumer.customer_address ? <h5 style={{ marginBottom: 18 }}>آدرس : {serviceConsumer.customer_address}</h5> : ''}
                                        <h5 style={{ marginBottom: 18 }}>توضیحات : {serviceConsumer.description || '-'}</h5>
                                    </div>
                                    <div >
                                        <h5 style={{ marginBottom: 18 }}>تاریخ چاپ فاکتور : {new Date().toLocaleDateString('fa-IR')}</h5>
                                        <h5 style={{ marginBottom: 18 }}>ساعت چاپ فاکتور : {new Date().toLocaleTimeString('fa-IR')}</h5>
                                        <h5 style={{ marginBottom: 18 }}>کاربر چاپ کننده : {userData.firstName + ' ' + userData.lastName}</h5>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6 p-4" style={{ width: '50%', display: 'block' }}>
                            <p > وضعیت   :
                                <span
                                    className={`${serviceConsumer.statusTitle === "منتظر تایید" ? "badge bg-warning px-4 py-1" :
                                        serviceConsumer.statusTitle === "ثبت درخواست" ? "badge bg-secondary px-3  py-1" :
                                            serviceConsumer.statusTitle === "لغو شده" ? "badge bg-danger px-3  py-1" :
                                                "badge bg-success px-3"}`}
                                >{serviceConsumer.statusTitle}
                                </span>
                            </p>
                            {serviceConsumer.additionalInfo && Object.keys(serviceConsumer.additionalInfo).length ?
                                <>
                                    <h4 style={{ paddingBottom: 20, marginBottom: 5, marginTop: 50 }}>اطلاعات استفاده کننده</h4>
                                    <h5 style={{ marginBottom: 18 }}>نام : {serviceConsumer.additionalInfo.firstName + ' ' + serviceConsumer.additionalInfo.lastName}</h5>
                                    <h5 style={{ marginBottom: 18 }}>کد ملی : {serviceConsumer.additionalInfo.nationalCode || '-'}</h5>
                                    <h5 style={{ marginBottom: 18 }}>شماره همراه : {serviceConsumer.additionalInfo.mobile || '-'}</h5>
                                    {serviceConsumer.additionalInfo.insuranceNo ? <h5 style={{ marginBottom: 18 }}>شماره بیمه : {serviceConsumer.additionalInfo.insuranceNo}</h5> : ''}
                                    {serviceConsumer.additionalInfo.insuranceDate ? <h5 style={{ marginBottom: 18 }}>تاریخ اعتبار بیمه : {serviceConsumer.additionalInfo.insuranceDate}</h5> : ''}
                                    {serviceConsumer.additionalInfo.description ? <h5 style={{ marginBottom: 18 }}>توضیحات : {serviceConsumer.additionalInfo.description}</h5> : ''}
                                </>
                                : <>
                                <h4 style={{ paddingBottom: 20, marginBottom: 5, marginTop: 50 }}>اطلاعات استفاده کننده</h4>
                                <h5 style={{ marginBottom: 18 }}>نام : {serviceConsumer.personFullName}</h5>
                                <h5 style={{ marginBottom: 18 }}>کد ملی : {serviceConsumer.nationalCode}</h5>
                            </>}
                        </div>
                    </div>

                    <div className=' p-4' style={{ paddingBottom: 30, borderTop: '2px solid #919090', borderBottom: '2px solid #919090' }}>
                        <h4 style={{ marginTop: 30, marginBottom: 30 }}>اطلاعات خدمت / خدمات خریداری شده</h4>
                        <table className="table pb-4 mb-4" style={{ borderTop: '2px solid #919090', borderBottom: '2px solid #919090', paddingBottom: 50 }}>
                            <thead style={{ borderBottom: '2px solid #919090', borderRight: '2px solid #919090', borderLeft: '2px solid #919090' }}>
                                <tr>
                                    <th style={{ borderLeft: '2px solid #919090' }}>ردیف</th>
                                    <th style={{ borderLeft: '2px solid #919090' }}>مرکز ارائه خدمت</th>
                                    <th style={{ borderLeft: '2px solid #919090' }}>عنوان</th>
                                    <th style={{ borderLeft: '2px solid #919090' }}>قیمت</th>
                                    <th style={{ borderLeft: '2px solid #919090' }}>تعداد</th>
                                    <th style={{ borderLeft: '2px solid #919090' }}>قیمت کل</th>
                                </tr>
                            </thead>
                            <tbody style={{ borderBottom: '2px solid #919090', borderRight: '2px solid #919090', borderLeft: '2px solid #919090' }}>
                                {serviceConsumer.subServices ? serviceConsumer.subServices.map((service, index) => (
                                    <tr style={{ borderBottom: '2px solid #919090' }} key={index}>
                                        <td style={{ borderLeft: '2px solid #919090' }}>{index + 1}</td>
                                        <td style={{ borderLeft: '2px solid #919090' }}>{serviceConsumer.businessTitle}</td>
                                        <td style={{ borderLeft: '2px solid #919090' }}>{service.title}</td>
                                        <td style={{ borderLeft: '2px solid #919090' }}>{new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 20 }).format(service.price)} ریال</td>
                                        <td style={{ borderLeft: '2px solid #919090' }}>{service.count}</td>
                                        <td style={{ borderLeft: '2px solid #919090' }}>{new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 20 }).format(service.price * service.count)} ریال</td>
                                    </tr>
                                )) : ''}
                            </tbody>
                            <tfoot>
                                <tr style={{ borderLeft: '2px solid #919090' }}>
                                    <td style={{ borderRight: '2px solid #919090', borderLeft: '2px solid #919090' }} colSpan="3">جمع کل</td>
                                    <td style={{ borderLeft: '2px solid #919090' }}>{new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalServicePrice)} ریال</td>
                                    <td style={{ borderLeft: '2px solid #919090' }}>{serviceConsumer.totalServiceCount}</td>
                                    <td style={{ borderLeft: '2px solid #919090' }}>{new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalPay)} ریال</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div className='p-4'>
                        <h4 className='mt-4 mb-3' >اطلاعات پرداخت</h4>
                        <p className="buyer-name">   روش پرداخت : {serviceConsumer.payment_Type || '-'} </p>
                        <p className="buyer-name">  مبلغ کل : {new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalPay)} ریال </p>
                        <p className="total-amount">  مبلغ پرداخت شده	 :  {new Intl.NumberFormat('fa-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalPay)} ریال
                        </p>
                    </div>

                </div>


            </div>
        </div>
    )
}

export default Factor;